import { render, staticRenderFns } from "./PushBasicEmployee.vue?vue&type=template&id=5c875e9b&scoped=true&"
import script from "./PushBasicEmployee.vue?vue&type=script&lang=js&"
export * from "./PushBasicEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c875e9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c875e9b')) {
      api.createRecord('5c875e9b', component.options)
    } else {
      api.reload('5c875e9b', component.options)
    }
    module.hot.accept("./PushBasicEmployee.vue?vue&type=template&id=5c875e9b&scoped=true&", function () {
      api.rerender('5c875e9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Payrolls/PushBasicEmployee.vue"
export default component.exports